<template>
  <div class="clients">
    <div class="hero d-flex align-items-center">
      <div class="reversed-row-mobile w-100">
        <div class="container">
          <h3>
            Deze klanten leveren meer en betere zorg dankzij Roosterplatform
          </h3>
          <h1>
            "Wij helpen 40 extra cliënten per jaar met hetzelfde aantal
            behandelaars dankzij Roosterplatform."
          </h1>
          <p>
            Lees hoe Norschoten jaarlijks 40 extra cliënten helpt met dezelfde
            behandelaars door geautomatiseerd te plannen met Roosterplatform. Of
            hoe Noorderbreedte wekelijks 60 uur met Roosterplatform bespaart of
            hoe Zinzia met Roosterplatform de cliënttevredenheid vergroot en
            behandelaars productiever maakt.
          </p>
          <div class="case-study">
            <div class="row">
              <div class="col-12 col-xl-4">
                <div class="case-study-holder">
                  <div class="client-image">
                    <img
                      class="client-wallpaper"
                      src="../assets/img/clients/hero-norschoten.png"
                      alt=""
                    >
                    <img
                      class="client-logo"
                      src="../assets/img/clients/logo-norschoten.png"
                      alt=""
                    >
                  </div>
                  <div class="case-study-title">
                    <b>Norschoten</b>: "Wij helpen 40 extra cliënten per jaar
                    met hetzelfde aantal behandelaars dankzij Roosterplatform."
                  </div>
                  <router-link
                    to="/norschoten"
                    class="button secondary-button"
                    tag="button"
                  >
                    Lees case study
                  </router-link>
                </div>
              </div>
              <div class="col-12 col-xl-4">
                <div class="case-study-holder">
                  <div class="client-image">
                    <img
                      class="client-wallpaper"
                      src="../assets/img/clients/hero-noorderbreedte.png"
                      alt=""
                    >
                    <img
                      class="client-logo"
                      src="../assets/img/clients/logo-noorderbreedte.png"
                      alt=""
                    >
                  </div>
                  <div class="case-study-title">
                    Hoe de behandelaars van <b>Noorderbreedte Revalidatie</b>
                    gezamenlijk wekelijks 60 uur met Roosterplatform besparen
                  </div>
                  <router-link
                    to="/noorderbreedte"
                    class="button secondary-button"
                    tag="button"
                  >
                    Lees case study
                  </router-link>
                </div>
              </div>
              <div class="col-12 col-xl-4">
                <div class="case-study-holder">
                  <div class="client-image">
                    <img
                      class="client-wallpaper"
                      src="../assets/img/clients/hero-zinzia.png"
                      alt=""
                    >
                    <img
                      class="client-logo"
                      src="../assets/img/clients/logo-zinzia.png"
                      alt=""
                    >
                  </div>
                  <div class="case-study-title">
                    Tevreden cliënten en productievere behandelaars bij
                    <b>zorggroep Zinzia</b> dankzij Roosterplatform
                  </div>
                  <router-link
                    to="/zinzia"
                    class="button secondary-button"
                    tag="button"
                  >
                    Lees case study
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section primary extra-padding-bottom">
      <app-clients-grid />
    </div>
  </div>
</template>
<script>
export default {
  name: "Clients",

  mounted() {},
  methods: {},
  metaInfo() {
    return {
      title: "Roosterplatform - Klanten",
    };
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";

.hero {
  padding: 100px 0;

  p {
    font-size: $big;
  }
  h3 {
    opacity: 0.3;
    font-weight: 700;
  }
}
.case-study {
  margin: 50px 0 0;
}

.case-study-holder {
  background: $grey-light;
  padding: 24px;
  border-radius: $border-radius;
  overflow: hidden;

  .client-image {
    position: relative;
    margin: -24px -24px 24px -24px;

    .client-wallpaper {
      position: relative;
    }

    .client-logo {
      position: absolute;
      z-index: 4;
      bottom: 8px;
      right: 8px;
      width: 100px;
    }
  }

  .button {
    background: $white;
  }

  .case-study-title {
    margin: 10px 0 20px 0;
    min-height: 80px;
  }
}

@media (max-width: 991px) {
  .hero {
    padding: 50px 0 220px;
    min-height: 0;
    background: none;
    &:after {
      width: 100%;
      bottom: 0;
      height: 200px;
    }
  }
  .reversed-row-mobile {
    z-index: 1;
  }
}
</style>
